import { Route } from "@angular/router";
import { LectureBilanRouting } from "./lecture-bilan/lecture-bilan-routing";
import { LectureCabComponent } from "./lecture-cab.component";
import { LectureHistoriqueRouting } from "./lecture-historique/lecture-historique-routing";
import { LectureImportRouting } from "./lecture-import/lecture-import-routing";

export const LectureCabRouting: Route = {
  path: 'cab',
  component: LectureCabComponent,
  data: {
    breadcrumb: "Lecture"
  },
  children: [
    LectureImportRouting,
    LectureHistoriqueRouting,
    LectureBilanRouting,
    { path: '', redirectTo: 'historique', pathMatch: 'full' },
  ]
};
